import SectionHeading from '../common/SectionHeading';
import { services } from '../../data/siteContent';

function ServicesSection() {
  return (
    <section className="block services-section" id="service">
      <div className="wrap">
        <SectionHeading eyebrow="SERVICE" title="이런 것들을 도와드립니다">처음 가입하시는 분도, 이미 여러 보험을 가지고 계신 분도 괜찮습니다.</SectionHeading>
        <div className="services-grid">
          {services.map(([title, body], index) => (
            <article className="service-item reveal" key={title}>
              <span className="service-number">{String(index + 1).padStart(2, '0')}</span>
              <div><h3>{title}</h3><p>{body}</p></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
